import { createLazyComponent, LazyModule } from 'owa-bundling';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyfindBulkActionItemAction, lazySubscribeToBulkActionNotification, } from 'owa-bulk-action-store';
import { runAfterInitialRender } from 'owa-delayed-initialization';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "BulkActions" */ './lazyIndex');
});
export var BulkActionProgressBar = createLazyComponent(lazyModule, function (m) { return m.BulkActionProgressBar; });
runAfterInitialRender(function () {
    if (isMailFeatureEnabled('tri-bulkActionNotification')) {
        lazyfindBulkActionItemAction.importAndExecute();
        lazySubscribeToBulkActionNotification.importAndExecute();
    }
});
//# sourceMappingURL=index.js.map